import { render, staticRenderFns } from "./SacRequest.vue?vue&type=template&id=24d67b4e"
import script from "./SacRequest.vue?vue&type=script&lang=js"
export * from "./SacRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports